<template>
    <v-dialog v-model="show" width="300">
        <v-card class="pa-5">
            <v-layout justify-center mb-5>
                <v-flex v-if="typeof message === 'string'" shrink :class="{ 'text-center': centerText }">
                    {{message}}
                </v-flex>
                <v-flex v-else shrink>
                    <div v-for="(m, i) in message" :key="i" :class="{ 'text-center': centerText }">
                      {{m}}
                    </div>
                </v-flex>
            </v-layout>
            <div v-if="!noBtn" class="d-flex justify-center">
                <GreenButton label="OK" @onPress="eventClick"></GreenButton>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
    import GreenButton from "../buttons/GreenButton";
    export default {
        components: {
            GreenButton
        },
        props: ["show", "message", "noBtn", "centerText"],
        methods: {
            eventClick() {
                this.$emit('onConfirm');
            }
        }
    }
</script>

<style scoped>

</style>
